import type { ComponentChildren } from "preact";
import { Icon, type IconName } from "./icon";

const TONES = {
	bad: "bg-carmesim-100 text-carmesim-700 dark:bg-carmesim-900 dark:text-carmesim-200",
	neutral: "border border-line-strong bg-surface-sunken text-ink",
};

// A full-width state of the record (dying, dead): an icon, what it is, one line saying what follows, and its actions.
export function StatusBand({
	tone,
	icon,
	title,
	text,
	children,
}: {
	tone: keyof typeof TONES;
	icon: IconName;
	title: string;
	text: string;
	children?: ComponentChildren;
}) {
	return (
		<div class={`cs-band flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl px-2.5 py-2 ${TONES[tone]}`}>
			<Icon name={icon} class="h-[26px] w-[26px]" />
			<div class="flex min-w-[150px] flex-1 flex-col leading-tight">
				<b class="cs-title text-[17px]">{title}</b>
				<span class="text-[13px]">{text}</span>
			</div>
			{children && <div class="flex w-full flex-wrap items-center justify-center gap-3">{children}</div>}
		</div>
	);
}
